import { useClearRefinements } from "react-instantsearch";

export default function useClearFilters() {
  const { canRefine, refine } = useClearRefinements();

  return {
    canClear: canRefine,
    clear: () => refine(),
  };
}
